'use client'
import { dateService } from '@/core/services/date'
import { FormDateInput } from '@/core/ui/forms/date-input'
import { FormTimeInput } from '@/core/ui/forms/time-input'
import { useReservationStore } from '@/features/reservation/store'
import { MIN_HOURS_BEFORE_TRIP_UPDATE } from '@/features/trips/constants'
import { useTranslations } from 'next-intl'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { BookFormModel } from '../../types/models/book-form.model'

type Props = { initialValues?: BookFormModel }

export const DateTimeInput: React.FC<Props> = ({ initialValues }) => {
  const t = useTranslations()
  const { control, watch, setValue } = useFormContext()
  const selectedDate = watch('date')
  const city = useReservationStore(state => state.city)
  const timeZone = city?.timeZone || ''

  const isToday = dateService.isToday(selectedDate)
  const initialTime = initialValues?.time
  const hasInitialTime = Boolean(initialValues?.time)
  const initialDate = initialValues?.date

  useEffect(() => {
    const currentDateByTimeZone = dateService.getCurrentDateByTimeZone(timeZone)
    if (initialDate === currentDateByTimeZone.toString() || hasInitialTime)
      return
    setValue(
      'time',
      dateService.roundMinutes(
        dateService.addHours(
          currentDateByTimeZone,
          MIN_HOURS_BEFORE_TRIP_UPDATE,
        ),
      ),
    )
  }, [timeZone, setValue, initialDate, hasInitialTime])
  useEffect(() => {
    if (initialDate) setValue('date', initialDate)
    if (initialTime) setValue('time', initialTime)
  }, [initialDate, initialTime, setValue])

  const handleDateChange = (newDate: Date) => {
    const currentDateByTimeZone = dateService.getCurrentDateByTimeZone(timeZone)

    if (
      initialDate ??
      dateService.dateToYyMmDd(newDate) !==
        dateService.dateToYyMmDd(currentDateByTimeZone)
    ) {
      return
    }
    setValue(
      'time',
      dateService.roundMinutes(
        dateService.addHours(
          currentDateByTimeZone,
          MIN_HOURS_BEFORE_TRIP_UPDATE,
        ),
      ),
    )
  }
  const minDate = dateService
    .addHours(new Date(), MIN_HOURS_BEFORE_TRIP_UPDATE)
    .toLocaleDateString([], {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    })
  let minTime: string | undefined = undefined
  if (isToday) {
    const currentDateByTimeZone = dateService.getCurrentDateByTimeZone(timeZone)

    minTime = dateService
      .addHours(currentDateByTimeZone, MIN_HOURS_BEFORE_TRIP_UPDATE)
      .toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
  }

  return (
    <div className='flex w-full flex-col items-start gap-3 sm:flex-row'>
      <FormDateInput
        control={control}
        name='date'
        label={t('forms.datePH')}
        labelClassName='text-grey'
        className='text-navy w-full flex-1 text-sm'
        onDateChange={handleDateChange}
        minDate={minDate}
      />
      <FormTimeInput
        control={control}
        name='time'
        label={t('forms.timePH')}
        labelClassName='text-grey'
        className='text-navy w-full flex-1 text-sm'
        minTime={minTime}
      />
    </div>
  )
}
